import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslationService } from 'src/app/shared/i18n/translation.service';

export class LanguageFlag {
  lang: string = "";
  name: string = "";
  flag: string = "";
  active?: boolean = false;
}

@Component({
    selector: 'app-language-selector-front-end',
    templateUrl: './language-selector-front-end.component.html',
    styleUrls: ['./language-selector-front-end.component.scss'],
    standalone: false
})
export class LanguageSelectorFrontEndComponent implements OnInit {

  classApplied = false;
  toggleClass() {
      this.classApplied = !this.classApplied;
  }

  classApplied2 = false;
  toggleClass2() {
      this.classApplied2 = !this.classApplied2;
  }

  classApplied3 = false;
  toggleClass3() {
      this.classApplied3 = !this.classApplied3;
  }
  language: LanguageFlag = new LanguageFlag();
  languages: LanguageFlag[] = [
    {
        lang: 'en',
        name: 'En',
        flag: './assets/img/us-flag.jpg',
    },
    {
        lang: 'de',
        name: 'Ger',
        flag: './assets/img/germany-flag.jpg',
    }
];
  constructor(
    private translationService: TranslationService,
    private router: Router
  ) { }
 
  ngOnInit() {
    this.setSelectedLanguage();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        this.setSelectedLanguage();
      });
  }

  setLanguageWithRefresh(lang: any) {
    this.setLanguage(lang);
    document.documentElement.setAttribute('lang', 'de');
    window.location.reload();
  }
  
  setLanguage(lang: any) {
    this.languages.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
    this.translationService.setLanguage(lang);
  }

  setSelectedLanguage(): any {
    this.setLanguage(this.translationService.getSelectedLanguage());
  }




  
}
